export const PREFIX = {
    memPlatform: '/mem-server'
};
